import { InputBase } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomNativeSelect = styled(InputBase, {
  shouldForwardProp: (prop) => prop !== 'textAlign',
})(({ theme, textAlign = 'left' }) => ({
  '& .MuiInputBase-input': {
    textAlign,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    // border: '1px solid #ced4da',
    border: 'none',
    fontSize: 14,
    width: '50px',
    // padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      border: 'none',
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
    '&.MuiNativeSelect-select': {
      paddingLeft: 0,
    },
  },
  '&:focus': {
    backgroundColor: 'transparent',
  },
}));

export default CustomNativeSelect;
